module.exports = __webpack_public_path__ + "static/media/Logo.d7d07399.png";